import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { AuthProvider } from '@/auth';
import { generalTheme } from '@/shared/general-theme';
import { CustomSnackbarProvider, GlobalContextProvider } from '@/shared/providers';

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={generalTheme}>
      <CssBaseline />

      <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GlobalContextProvider>
            <CustomSnackbarProvider>
              {children}
            </CustomSnackbarProvider>
        </GlobalContextProvider>
      </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
